import Brand from './Brand';

export default function Header({onHomeClick, onOrdersClick, onCtaClick, overlay = false}) {
    const isHome = window.location.pathname === '/' || window.location.pathname === '';

    const handleHomeClick = (e) => {
        if (isHome && onHomeClick) {
            e.preventDefault();
            onHomeClick();
        }
    };

    const handleOrdersClick = (e) => {
        if (onOrdersClick) {
            e.preventDefault();
            onOrdersClick();
        }
    };

    const linkClass = `text-[15px] md:text-base font-semibold transition tracking-[-0.01em] ${
        overlay ? 'text-white/90 hover:text-white' : 'text-brand-dark hover:text-brand-red'
    }`;

    return (
        <div className="w-full max-w-[1110px] mx-auto px-4 py-4 flex justify-between items-center gap-3">
            <a
                href="/"
                onClick={handleHomeClick}
                className="flex flex-col items-start hover:opacity-80 transition"
            >
                <Brand overlay={overlay}/>
            </a>

            {/* Лендинг ведёт в блог, приложение — к заказам. */}
            <nav className="flex items-center gap-5 md:gap-7">
                {overlay ? (
                    <a href="/blog/" className={linkClass}>Блог</a>
                ) : (
                    <a href="/orders" onClick={handleOrdersClick} className={linkClass}>Мои сказки</a>
                )}
            </nav>
        </div>
    );
}
